/* v94.4: footer columns become accordions on phones, and looping animations pause while their section is off
   screen, so at most what is in view moves. */
(function () {
  var ready = function (f) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', f); else f(); };
  ready(function () {
    /* Footer accordions */
    document.querySelectorAll('footer .footer-block').forEach(function (b, i) {
      var h = b.querySelector('.footer-block__heading'), c = b.querySelector('.footer-block__details-content');
      if (!h || !c) return;
      b.classList.add('pw-acc');
      if (!c.id) c.id = 'pw-acc-' + i;
      h.setAttribute('role', 'button'); h.setAttribute('tabindex', '0');
      h.setAttribute('aria-controls', c.id); h.setAttribute('aria-expanded', 'false');
      var t = function () { var o = b.classList.toggle('is-open'); h.setAttribute('aria-expanded', o ? 'true' : 'false'); };
      h.addEventListener('click', function () { if (matchMedia('(max-width: 749px)').matches) t(); });
      h.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && matchMedia('(max-width: 749px)').matches) { e.preventDefault(); t(); } });
    });
    /* Pause animations off screen */
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { e.target.classList.toggle('pw-off', !e.isIntersecting); });
    }, { rootMargin: '80px 0px' });
    document.querySelectorAll('main > .shopify-section, .shopify-section-group-footer-group').forEach(function (s) { io.observe(s); });
  });
})();
